/* CLENZOR Landing Page — Interactive Scripts */

/* COUNTDOWN — Halloween Oct 31 2026, then Black Friday Nov 27 2026 (America/New_York) */
function pad(n){return String(n).padStart(2,'0')}
(function(){
  var hw=new Date('2026-10-31T04:00:00Z'); /* midnight EDT (UTC-4) */
  var bf=new Date('2026-11-28T05:00:00Z'); /* midnight EST (UTC-5) */
  var now=new Date();
  var target=now<hw?hw:bf;
  var label=now<hw?'Halloween in':'Black Friday in';
  var cdLbl=document.querySelector('.cd-label');
  if(cdLbl)cdLbl.textContent=label;
  function tick(){
    var diff=target-new Date();
    if(diff<=0){
      ['h-d','h-h','h-m','h-s','u-d','u-h','u-m','u-s'].forEach(function(id){
        var el=document.getElementById(id);if(el)el.textContent='00';
      });
      return;
    }
    var d=Math.floor(diff/864e5),h=Math.floor(diff%864e5/36e5),m=Math.floor(diff%36e5/6e4),s=Math.floor(diff%6e4/1e3);
    ['h-d','u-d'].forEach(function(id){var el=document.getElementById(id);if(el)el.textContent=pad(d);});
    ['h-h','u-h'].forEach(function(id){var el=document.getElementById(id);if(el)el.textContent=pad(h);});
    ['h-m','u-m'].forEach(function(id){var el=document.getElementById(id);if(el)el.textContent=pad(m);});
    ['h-s','u-s'].forEach(function(id){var el=document.getElementById(id);if(el)el.textContent=pad(s);});
  }
  tick();setInterval(tick,1000);
})();

/* HERO MORPH */
var words=['Halloween','Black Friday','Christmas','Grand Opening'];
var colors=['#FF6B1A','#F5C518','#4ADE80','#D4AF37'];
var idx=0;
var morphEl=document.getElementById('morphEl');
function morph(){
  idx=(idx+1)%words.length;
  morphEl.style.transition='transform .38s cubic-bezier(.7,0,1,1),opacity .28s ease';
  morphEl.style.transform='translateY(-105%)';morphEl.style.opacity='0';
  setTimeout(function(){
    morphEl.innerHTML=words[idx];morphEl.style.color=colors[idx];
    morphEl.style.transition='none';morphEl.style.transform='translateY(105%)';morphEl.style.opacity='0';
    requestAnimationFrame(function(){requestAnimationFrame(function(){
      morphEl.style.transition='transform .52s cubic-bezier(.16,1,.3,1),opacity .38s ease';
      morphEl.style.transform='translateY(0)';morphEl.style.opacity='1';
    });});
  },360);
}
if(morphEl)setInterval(morph,2800);

/* TABS */
document.querySelectorAll('.tb').forEach(function(b){
  b.addEventListener('click',function(){
    var t=b.dataset.tab;
    document.querySelectorAll('.tb').forEach(function(x){x.classList.remove('active');});
    document.querySelectorAll('.tpanel').forEach(function(x){x.classList.remove('active');});
    b.classList.add('active');
    var panel=document.getElementById('tab-'+t);
    if(panel)panel.classList.add('active');
  });
});

/* FAQ */
document.querySelectorAll('.fqb').forEach(function(b){
  b.addEventListener('click',function(){
    var r=b.closest('.frow'),o=r.classList.contains('open');
    document.querySelectorAll('.frow').forEach(function(x){x.classList.remove('open');});
    if(!o)r.classList.add('open');
  });
});

/* SCROLL REVEAL */
var obs=new IntersectionObserver(function(entries){
  entries.forEach(function(e){if(e.isIntersecting)e.target.classList.add('in');});
},{threshold:.1,rootMargin:'0px 0px -50px 0px'});
document.querySelectorAll('.reveal').forEach(function(e){obs.observe(e);});

/* NAV COMPACT + STICKY BAR */
var sbar=document.getElementById('sbar');
var heroBottom=0;
function setHeroBottom(){
  var h=document.getElementById('hero');
  if(h)heroBottom=h.offsetTop+h.offsetHeight;
}
setHeroBottom();
window.addEventListener('resize',setHeroBottom,{passive:true});
window.addEventListener('scroll',function(){
  var s=window.scrollY;
  var nav=document.querySelector('nav');
  if(nav)nav.style.padding=s>60?'12px 48px':'18px 48px';
  if(sbar){
    if(s>heroBottom-100)sbar.classList.add('show');
    else sbar.classList.remove('show');
  }
},{passive:true});

/* HERO PARALLAX */
(function(){
  var hero=document.getElementById('hero');
  if(!hero)return;
  var wraps=document.querySelectorAll('.fcp');
  var depths=[0.9,1.35,0.6,1.55,1.05,0.72];
  var tx=0,ty=0,raf=null;
  function apply(){
    raf=null;
    wraps.forEach(function(w,i){
      var d=depths[i]||1;
      w.style.transform='translate('+tx*20*d+'px,'+ty*11*d+'px)';
    });
  }
  hero.addEventListener('mousemove',function(e){
    var r=hero.getBoundingClientRect();
    tx=(e.clientX-r.left-r.width*.65)/(r.width*.45);
    ty=(e.clientY-r.top-r.height*.5)/(r.height*.5);
    tx=Math.max(-1,Math.min(1,tx));
    ty=Math.max(-1,Math.min(1,ty));
    if(!raf)raf=requestAnimationFrame(apply);
  },{passive:true});
  hero.addEventListener('mouseleave',function(){
    tx=0;ty=0;
    if(!raf)raf=requestAnimationFrame(apply);
  });
})();

/* 3D CARD TILT */
(function(){
  document.querySelectorAll('.bcard').forEach(function(card){
    var raf=null;
    card.style.transition='transform .15s ease,border-color .3s,box-shadow .4s';
    card.addEventListener('mousemove',function(e){
      if(raf)return;
      raf=requestAnimationFrame(function(){
        raf=null;
        var r=card.getBoundingClientRect();
        var cx=(e.clientX-r.left-r.width/2)/(r.width/2);
        var cy=(e.clientY-r.top-r.height/2)/(r.height/2);
        card.style.transform='perspective(900px) rotateX('+(-cy*4.5)+'deg) rotateY('+(cx*4.5)+'deg) translateY(-10px) scale(1.015)';
      });
    },{passive:true});
    card.addEventListener('mouseleave',function(){
      card.style.transition='transform .55s cubic-bezier(.23,1,.32,1),border-color .3s,box-shadow .4s';
      card.style.transform='perspective(900px) rotateX(0deg) rotateY(0deg) translateY(0) scale(1)';
    });
  });
})();

/* TEMPLATE TILE HOVER 3D */
(function(){
  document.querySelectorAll('.t').forEach(function(tile){
    tile.addEventListener('mousemove',function(e){
      var r=tile.getBoundingClientRect();
      var cx=(e.clientX-r.left-r.width/2)/(r.width/2);
      var cy=(e.clientY-r.top-r.height/2)/(r.height/2);
      tile.style.transform='perspective(400px) rotateX('+(-cy*6)+'deg) rotateY('+(cx*6)+'deg) scale(1.06)';
    },{passive:true});
    tile.addEventListener('mouseleave',function(){tile.style.transform='';});
  });
})();
